<template>
  <div :class="isSP ? 'home--sp' : 'home--pc'">
    <visual :class="isSP ? 'home__visual--sp' : 'home__visual--pc'" />
    <div class="home__title">
      <h2 :class="isSP ? 'home__title__sub--sp' : 'home__title__sub--pc'">私たちの物語</h2>
      <div :class="isSP ? 'home__title__line--sp' : 'home__title__line--pc'" />
      <h2 :class="isSP ? 'home__title__english--sp' : 'home__title__english--pc'">This is our Story</h2>
    </div>
    <story :class="isSP ? 'home__story--sp' : 'home__story--pc'" />
    <div class="home__title">
      <h2 :class="isSP ? 'home__title__sub--sp' : 'home__title__sub--pc'">掲載メディア</h2>
      <div :class="isSP ? 'home__title__line--sp' : 'home__title__line--pc'" />
      <h2 :class="isSP ? 'home__title__english--sp' : 'home__title__english--pc'">Media Appearances</h2>
    </div>
    <media :class="isSP ? 'home__media--sp' : 'home__media--pc'" />
    <div class="home__title">
      <h2 :class="isSP ? 'home__title__sub--sp' : 'home__title__sub--pc'">記事一覧</h2>
      <div :class="isSP ? 'home__title__line--sp' : 'home__title__line--pc'" />
      <h2 :class="isSP ? 'home__title__english--sp' : 'home__title__english--pc'">List of Articles</h2>
    </div>
    <original-article :class="isSP ? 'home__article--sp' : 'home__article--pc'" />
    <a :class="isSP ? 'home__btn--sp' : 'home__btn--pc'"
       href="https://docs.google.com/forms/d/e/1FAIpQLScIFe15Xe2yv9fca1jOxHmr6ET-PgZTOxbBAhLliyeCHwaIuw/viewform"
       target="_blank">
      お問い合わせ
      <v-icon :class="isSP ? 'home__btn__arrow--sp' : 'home__btn__arrow--pc'">arrow_forward_ios</v-icon>
    </a>
  </div>
</template>

<script>
import Visual from '@/components/visual'
import Story from '@/components/story'
import Media from '@/components/media'
import OriginalArticle from '@/components/article'

export default {
  name: 'home',
  components: { Visual, Story, Media, OriginalArticle },
  computed: {
    /**
     * @return {Boolean} SPかどうか
     */
    isSP () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/color.scss';
@import '@/assets/sass/size.scss';

.home {
  text-align: center;
  &--sp {
    @extend .home;
    margin-top: $header_height_sp;
  }
  &--pc {
    @extend .home;
    margin-top: $header_height_pc;
  }
  &__title {
    margin-top: 100px;
    text-align: center;
    &__sub {
      font-weight: normal;
      &--sp {
        @extend .home__title__sub;
        font-size: 1.4rem;
      }
      &--pc {
        @extend .home__title__sub;
        font-size: 1.8rem;
      }
    }
    &__line {
      height: 1px;
      margin: 4px auto;
      background: $black_color;
      &--sp {
        @extend .home__title__line;
        width: 200px;
      }
      &--pc {
        @extend .home__title__line;
        width: 260px;
      }
    }
    &__english {
      font-weight: normal;
      &--sp {
        @extend .home__title__sub;
        font-size: 1.6rem;
      }
      &--pc {
        @extend .home__title__sub;
        font-size: 2.4rem;
      }
    }
  }
  &__story {
    &--sp {
      @extend .home__story;
      margin-top: 30px;
    }
    &--pc {
      @extend .home__story;
      margin-top: 60px;
    }
  }
  &__media {
    &--sp {
      @extend .home__media;
      margin-top: 30px;
    }
    &--pc {
      @extend .home__media;
      margin-top: 60px;
    }
  }
  &__article {
    &--sp {
      @extend .home__article;
      margin-top: 30px;
    }
    &--pc {
      @extend .home__article;
      margin-top: 60px;
    }
  }
  &__btn {
    display: inline-block;
    color: $orange_color;
    border: 1px solid $orange_color;
    &--sp {
      @extend .home__btn;
      padding: 10px 20px;
      margin: 120px auto 100px auto;
      font-size: 1.4rem;
      line-height: 1.8rem;
      border-radius: 28px;
    }
    &--pc {
      @extend .home__btn;
      padding: 20px 38px;
      margin: 180px auto 200px auto;
      font-size: 2.4rem;
      line-height: 3.4rem;
      border-radius: 28px;
    }
    &__arrow {
      margin-left: 0;
      &.theme--light.v-icon {
        color: $orange_color;
      }
      &--sp {
        @extend .home__btn__arrow;
        margin-top: -4px;
        &.v-icon.v-icon {
          font-size: 1.8rem;
        }
      }
      &--pc {
        @extend .home__btn__arrow;
        margin-top: -4px;
        &.v-icon.v-icon {
          font-size: 3.4rem;
        }
      }
    }
  }
}
</style>
